import { createSelector } from 'reselect';
import { get } from 'lodash/fp';

export const selectFees = get('apps.employer-experience.feesReducer');

export const selectFeeStatus = createSelector(selectFees, fees => fees?.status);
